import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";

import Notification from "./Header/HeaderContent/Notification";
import MobileHeaderMenu from "./Header/HeaderContent/MobileHeaderMenu";
import AdminNotificationSection from "components/AdminNotificationSection";
import GlobalPointsDisplay from "./Header/HeaderContent/GlobalPointsDisplay";
import QuickNavButton from "./Header/HeaderContent/QuickNavButton";
import NavUser from "./Drawer/DrawerContent/NavUser";
import { useGlobalSearch } from "hooks/useGlobalSearch";

import { handlerDrawerOpen } from "api/menu";
import useAuth from "hooks/useAuth";
import { canAccessAdminPanel, isFullAdmin } from "utils/adminAccess";
import { headerIconButtonSx, V2 } from "./Header/headerV2Tokens";
import { PanelLeftOpen, Search } from "lucide-react";

// ==============================|| V2 SCROLLABLE PAGE CHROME ||============================== //

/**
 * Top action row for V2 shell routes — lives inside scrollable main (not a fixed AppBar).
 * Left: mobile drawer open. Right: search / points / quick nav / notifications / profile.
 */
export default function PageChrome() {
  const { user } = useAuth();
  const isAdmin = canAccessAdminPanel(user);
  const downLG = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  const downXS = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const { open: searchOpen, toggle: toggleSearch } = useGlobalSearch();

  const searchButton = (
    <IconButton
      aria-label="Rechercher"
      onClick={toggleSearch}
      color="secondary"
      size="large"
      sx={headerIconButtonSx(searchOpen)}
    >
      <Search
        size={20}
        color={searchOpen ? V2.accent : V2.ink}
        strokeWidth={1.7}
      />
    </IconButton>
  );

  return (
    <>
      <Box
        className="dashboard-v2-page-chrome"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: { xs: 1, sm: 1.5 },
          width: "min(1180px, 100%)",
          maxWidth: 1180,
          mx: "auto",
          pt: { xs: 1.5, sm: 2 },
          pb: { xs: 2, sm: 2.5 },
          mb: { xs: 1.5, sm: 2.5 },
          boxSizing: "border-box",
          fontFamily: V2.fontBody,
        }}
      >
        {downLG ? (
          <IconButton
            aria-label="Ouvrir le menu"
            onClick={() => handlerDrawerOpen(true)}
            edge="start"
            color="secondary"
            size="large"
            sx={headerIconButtonSx(false)}
          >
            <PanelLeftOpen size={20} color={V2.ink} strokeWidth={1.7} />
          </IconButton>
        ) : (
          <Box aria-hidden sx={{ width: 0, height: 0 }} />
        )}

        <Stack
          direction="row"
          spacing={{ xs: 0.75, sm: 1 }}
          alignItems="center"
          sx={{ ml: "auto", flexShrink: 0 }}
        >
          {!downXS && (
            <>
              {searchButton}
              <GlobalPointsDisplay />
              <QuickNavButton isAdmin={isAdmin} />
              <AdminNotificationSection />
              {isFullAdmin(user) ? null : <Notification />}
              <NavUser />
            </>
          )}
          {downXS && (
            <>
              {searchButton}
              <MobileHeaderMenu />
            </>
          )}
        </Stack>
      </Box>
    </>
  );
}
